export const apiCreateProposal = "1.0/wsm/warehouse/create/approval"
export const apiGetListProposal = "1.0/wsm/warehouse/list/approval"
export const apiGetDetailProposal = id =>
  `1.0/wsm/warehouse/${id}/detail/approval`
export const apiUpdateProposal = id => `1.0/wsm/warehouse/${id}/update/approval`
export const apiApproveProposal = id => `1.0/wsm/warehouse/${id}/browse`
export const apiRefuseProposal = id => `1.0/wsm/warehouse/${id}/refuse`
export const apiExportProposal = "1.0/wsm/warehouse/export/approval"
export const apiExportExcelProposal = `1.0/wsm/approval/export/sim`
export const apiImportInfoSimProposal = id =>
  `1.0/wsm/approval/import/${id}/sim`
export const apiDetailInfoSimProposal = id =>
  `1.0/wsm/approval/detail/${id}/sim`
export const apiUpdateDetailInfoSimProposal =
  "1.0/wsm/approval/update/sim/detail"

export const apiBuyFromProvider = `1.0/wsm/GGG/createOrder`

export const apiStatusSim = "1.0/wsm/GGG/getGigagOrder"

